/**
 * SkinGlow money formatting.
 * Renders the shop's money_format string so JavaScript-injected prices read
 * identically to the Liquid `money` filter. Shopify.formatMoney is not
 * available on this storefront (option_selection.js is never loaded), so the
 * placeholders are rendered here rather than delegated.
 * The theme and the app extension both ship this file; keep the copies byte
 * identical. money.browser.test.ts asserts that they are.
 */
(function () {
  var VERSION = 1;
  if (window.SKGMoney && window.SKGMoney.version === VERSION) return;

  var DEFAULT_FORMAT = "{{amount}} dh";

  // placeholder -> [thousands separator, decimal separator, decimal places]
  var RULES = {
    amount: [",", ".", 2],
    amount_no_decimals: [",", "", 0],
    amount_with_comma_separator: [".", ",", 2],
    amount_no_decimals_with_comma_separator: [".", "", 0],
    amount_with_apostrophe_separator: ["'", ".", 2],
    amount_with_space_separator: [" ", ",", 2],
    amount_no_decimals_with_space_separator: [" ", "", 0],
    amount_with_period_and_space_separator: [" ", ".", 2],
  };

  function group(digits, separator) {
    if (!separator) return digits;
    return digits.replace(/(\d)(?=(\d{3})+$)/g, function (match) {
      return match + separator;
    });
  }

  function render(cents, rule) {
    var value = Number(cents || 0) / 100;
    if (!isFinite(value)) value = 0;
    var parts = Math.abs(value).toFixed(rule[2]).split(".");
    var out = group(parts[0], rule[0]);
    if (parts[1]) out += rule[1] + parts[1];
    return (value < 0 ? "-" : "") + out;
  }

  /**
   * @param {number} cents
   * @param {string} [formatString] overrides window.SKGMoneyFormat, for tests.
   */
  function format(cents, formatString) {
    var template = formatString || window.SKGMoneyFormat || DEFAULT_FORMAT;
    // Some shops wrap the format in markup; we render into textContent.
    return String(template)
      .replace(/<[^>]*>/g, "")
      .replace(/\{\{\s*(\w+)\s*\}\}/g, function (match, name) {
        return RULES[name] ? render(cents, RULES[name]) : match;
      })
      .trim();
  }

  window.SKGMoney = { version: VERSION, format: format };
})();
